import { Route } from '@angular/router';

export const aroundTheClockStatisticsRoutes: Route[] = [
    {
        path: 'around-the-clock/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/around-the-clock-statistics-details/around-the-clock-statistics-details.component').then(
                (c) => c.AroundTheClockStatisticsDetailsComponent
            ),
    },
    {
        path: 'around-the-clock/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/around-the-clock-statistics-games/around-the-clock-statistics-games.component').then(
                (c) => c.AroundTheClockStatisticsGamesComponent
            ),
    },
    {
        path: 'around-the-clock/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import(
                './pages/around-the-clock-statistics-games-details/around-the-clock-statistics-games-details.component'
            ).then((c) => c.AroundTheClockStatisticsGamesDetailsComponent),
    },
];
